export default [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: 'home' */ './views/Index.vue')
  }
]
